import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Context
import { BaseProvider } from "./context/Base.context";

// Components
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Header from "./components/Header/Header";
import TopicOverviewPage from "./pages/TopicOverview.page";
import TopicPage from "./pages/Topic.page";
import ContinuePage from "./pages/Continue.page";
import SavePage from "./pages/Save.page";
import FinishPage from "./pages/Finish.page";
import HowItWorksPage from "./pages/HowItWorks.page";
import HowSecureIsPage from "./pages/HowSecureIs.page";

// Misc.
import Topic from "./types/Topic.interface";

const App: React.FC = () => {
  const [data, setData] = React.useState<Topic[]>([]);
  const [navData, setNavData] = React.useState<Topic[]>([]);

  React.useEffect(() => {
    fetch("/resilience-scanner/api/v1/topics?populated")
      .then((response) => response.json())
      .then((topics: Topic[]) => {
        const publishedTopics: Topic[] = [];

        topics.forEach((topic) => {
          if (topic.published === 1) {
            publishedTopics.push(topic);
          }
        });

        setData(publishedTopics);
        setNavData(publishedTopics);
      });
  }, []);

  return (
    <BaseProvider>
      <Router basename="/resilience-scanner/app/">
        <ScrollToTop />
        <Header navData={navData} />
        <Switch>
          <Route exact path="/">
            <p>Home</p>
          </Route>
          <Route path="/categories">
            <TopicOverviewPage data={data} />
          </Route>
          <Route path="/category/:categoryId">
            <TopicPage />
          </Route>
          <Route path="/continue">
            <ContinuePage />
          </Route>
          <Route path="/save">
            <SavePage />
          </Route>
          <Route path="/finish">
            <FinishPage topics={data} />
          </Route>
          <Route path="/faq/usage">
            <HowItWorksPage />
          </Route>
          <Route path="/faq/security">
            <HowSecureIsPage />
          </Route>
        </Switch>
      </Router>
    </BaseProvider>
  );
};

export default App;
